export function Float(value, round = 2, isMaybeNegative = false) {
    let return_value = String(value);
    if (return_value.match(',')) {
        return_value = return_value.replace(',', '.');
    }
    if (return_value.match('..')) {
        return_value = return_value.replace('..', '.');
    }
    if (isMaybeNegative) {
        if (return_value[0] !== '-') {
            isMaybeNegative = false;
        }
    }
    if (return_value.match(/[^0-9.]/g)) {
        return_value = (isMaybeNegative ? '-' : '') + return_value.replace(/[^0-9.]/g, '');
    }
    if (value) {
        if (f(value) > round) {
            return_value = Round(return_value, round);
        }
    }
    return return_value;
}

function Round(value, round) {
    let pow = Math.pow(10, round);
    return (Math.round(value * pow) / pow);
}

function f(n = '') {
    n = (typeof n === 'string') ? n : n.toString();
    if (n.indexOf('e') !== -1) return parseInt(n.split('e')[1]) * -1;
    let separator = (1.1).toString().split('1')[1];
    let parts = n.split(separator);
    return parts.length > 1 ? parts[parts.length - 1].length : 0;
}